import React, { useState, useContext } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styles from './DirectoryList.module.scss';
import * as _ from 'lodash';
import { AppContext } from '../../context/AppContext';
import { IAppContext } from '../../context/DefaultAppState';
import { getCategoriesToMap } from '../../lib/util';

export enum DirectoryListType {
  doctor = 'doctor',
  pharmacy = 'pharmacy',
  facility = 'hospital, facility, or other service',
  all = 'all',
  none = ''
}

const DirectoryList = () => {
  const appContext = useContext(AppContext);
  const { isDirectorySelected, directoryListType } = appContext;
  const [isShowingMore, setIsShowingMore] = useState(false);
  const showMessage = !isShowingMore ? 'Show More' : 'Show Less';
  return (
    <>
      {isDirectorySelected && directoryListType !== DirectoryListType.none && directoryListType !== DirectoryListType.all ? (
        <>
          <h3 className={styles.listMessage}>What kind of {directoryListType} are you looking for?</h3>
          <div className={styles.listContainer}>
            {getCategoriesToMap(isShowingMore, appContext, true).map((specialty) => (
              <div key={`dli-${specialty}`}>
                <Link className={styles.listItemLink} onClick={() => appContext.updateChosenSpecialty(specialty)} to={appContext.planState ? `/results/${appContext.planCode}/${appContext.directoryListType}/${specialty}/undefined/undefined` : `/state-selection`}>
				  {specialty}
                </Link>
              </div>
            ))}
          </div>
          <div className={styles.showMessageToggle} onClick={() => setIsShowingMore(!isShowingMore)}>
            {showMessage}
          </div>
        </>
      ) : null}
    </>
  );
};

export default withRouter(DirectoryList);
